<template>
  <section class="player-iframe-container">
    <div class="video-container-full">
      <player-page v-if="streamingInfo" :streamingInfo="streamingInfo" style="width: 100%; height: 100%" />
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, computed } from 'vue';
import { useRouter } from 'vue-router';
import { getStreamingInfo } from '@/api/streamingService.js';
import { useStore } from 'vuex';
import PlayerPage from '@/pages/programVideo/video/IframePlayer.vue';

const CHECK_STREAMING_INTERVAL = 30000;

const store = useStore();
const router = useRouter();
const currentLanguage = computed(() => store.state.currentLanguage);
const roomId = computed(() => router.currentRoute.value.params.roomId);

const streamingInfo = ref(null);
const checkStreamingInterval = ref(null);

onMounted(async () => {
  await fetchStreamingInfo();

  checkStreamingInterval.value = setInterval(() => {
    fetchStreamingInfo();
  }, CHECK_STREAMING_INTERVAL);
});

const fetchStreamingInfo = async () => {
  try {
    const langSetting = currentLanguage.value === 'zh_tw' ? 'zh-tw' : currentLanguage.value;
    const response = await getStreamingInfo(roomId.value, langSetting);

    if (response?.data?.data) {
      streamingInfo.value = response.data.data;
    }
  } catch (error) {
    console.error(error);
  }
};

onBeforeUnmount(() => {
  if (checkStreamingInterval.value) {
    clearInterval(checkStreamingInterval.value);
    checkStreamingInterval.value = null;
  }
});
</script>

<style lang="scss" scoped>
.player-iframe-container {
  width: 100vw !important;
  height: 100vh !important;
  margin: 0;
  padding: 0;
  overflow: hidden;
  background-color: #000;

  .video-container-full {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
